import { createSlice } from "@reduxjs/toolkit";
import api from "../../services";
import { API_RESPONSE, PLAYMATEZAPI } from "../../services/apiConstant";
import secureLocalStorage from "react-secure-storage";
import { toast } from "react-toastify";
import { TYPES } from "helper/constant";

const slice = createSlice({
  name: "profile",
  initialState: {
    userProfileData: null,
    marketPlaceRatingData: null,
    venueRatingData: null,
    venueAvailabilityDetails: null,
    isUpdateVenueLoading: null,
    venueSelectedSportsData: [],
    bookingAvailiabilityData: null,
    bookingAvailiabilityDetails: null,
    venueBookingSlotsList: null,
    venueBookedSlots: null,
    venueDetailsData: null,
    otherUserProfileData: null,
    connectionListData: null,
    vanueList: [],
    joinRequestPlayerList: null, // 👈 ADD THIS
    userDetailData: null, // 👈 for View Profile
    eventList: [],
    gameCardList: [],
  },
  reducers: {
    apiFetching: (state, action) => {
      state.isLoading = true;
      if (action.payload == "addUpdateVenue") {
        state.isUpdateVenueLoading = true;
      }
      if (action.payload == "delete") {
        state.isDeleteAccountLoading = true;
      }
    },
    apiFailed: (state, action) => {
      state.isLoading = false;
      if (action.payload == "addUpdateVenue") {
        state.isUpdateVenueLoading = false;
      }
      if (action.payload == "delete") {
        state.isDeleteAccountLoading = false;
      }
    },
    // Rating
    getMarketPlaceRatingSuccess: (state, action) => {
      if (action.payload?.page == 1) {
        state.marketPlaceRatingData = action.payload?.data;
      } else {
        state.marketPlaceRatingData.data =
          state.marketPlaceRatingData.data.concat(action.payload?.data?.data);
      }
    },
    getVenueRatingSuccess: (state, action) => {
      if (action.payload?.page == 1) {
        state.venueRatingData = action.payload?.data;
      } else {
        state.venueRatingData.data = state.venueRatingData.data.concat(
          action.payload?.data?.data
        );
      }
    },
    // Venue operation
    venueAvailabilityDetailsSuccess: (state, action) => {
      state.venueAvailabilityDetails = action.payload;
    },
    venueSelectedSportsListSuccess: (state, action) => {
      state.venueSelectedSportsData = action.payload;
    },
    getBookingAvailiabilityListSuccess: (state, action) => {
      console.log("action.payload?.data", action.payload?.data?.data);
      if (action.payload?.page == 1) {
        state.bookingAvailiabilityData = action.payload?.data;
      } else {
        state.bookingAvailiabilityData.data =
          state.bookingAvailiabilityData.data.concat(
            action.payload?.data?.data
          );
      }
    },
    bookingAvailiabilityDetailsSuccess: (state, action) => {
      state.bookingAvailiabilityDetails = action.payload;
    },
    clearBookingAvailiabilityDetailsSuccess: (state, action) => {
      state.bookingAvailiabilityDetails = action.payload;
    },
    listOfVenueSlotsSuccess: (state, action) => {
      state.venueBookingSlotsList = action.payload;
    },
    getVenueBookedSlotListingSuccess: (state, action) => {
      state.venueBookedSlots = action.payload;
    },
    getUserDetailsSuccess: (state, action) => {
      state.userProfileData = action.payload;
    },
    deleteVenueBookingSuccess: (state, action) => {
      state.bookingAvailiabilityData.data = (
        state.bookingAvailiabilityData?.data || []
      ).filter((item) => item?._id != action.payload);
    },

    getVenueDetailsSuccess: (state, action) => {
      state.venueDetailsData = action.payload;
    },

    getOtherUserProfileDetailsSuccess: (state, action) => {
      state.otherUserProfileData = action.payload;
    },
    updateProfileSuccess: (state, action) => {
      state.userProfileData.data = action.payload;
    },
    getAcceptConnectionListSuccess: (state, action) => {
      state.connectionListData = action.payload;
    },
    fetchVanueListSuccess: (state, action) => {
      state.vanueList = action.payload;
    },
    getPlayerListSuccess: (state, action) => {
      if (action.payload?.page === 1) {
        state.joinRequestPlayerList = action.payload?.data;
      } else {
        state.joinRequestPlayerList.data =
          state.joinRequestPlayerList.data.concat(action.payload?.data?.data);
      }
    },
    getUserDetailSuccess: (state, action) => {
      state.userDetailData = action.payload;
    },
    getEventListV2Success: (state, action) => {
      if (action.payload?.page === 1) {
        state.eventList = action.payload?.data;
      } else {
        if (action.payload?.data) {
          state.eventList.data = state.eventList.data.concat(
            action.payload?.data?.data
          );
        } else {
          state.eventList = [];
        }
      }
    },
    getGameCardsSuccess: (state, action) => {
      if (action.payload?.page === 1) {
        state.gameCardList = action.payload?.data;
      } else {
        if (action.payload?.data) {
          state.gameCardList.data = state.gameCardList.data.concat(
            action.payload?.data?.data
          );
        } else {
          state.gameCardList = [];
        }
      }
    },
    getDetailsByReferenceIdSuccess: (state, action) => {
      state.referenceIdDetailData = action.payload;
    },
    getJoinRequestDetailSuccess: (state, action) => {
      state.joinRequestDetail = action.payload;
    },
    getGameOnCardDetailSuccess: (state, action) => {
      state.gameOnCardDetail = action.payload;
    },
    clearListOfVenueSlotsSuccess: (state, action) => {
      state.venueBookingSlotsList = null;
    },
  },
});

export default slice.reducer;

/**********************ACTIONS************************************************ */

const {
  apiFetching,
  apiFailed,
  //   Rating actions
  getMarketPlaceRatingSuccess,
  getVenueRatingSuccess,

  // Venue Operations Action
  venueAvailabilityDetailsSuccess,
  venueSelectedSportsListSuccess,
  getBookingAvailiabilityListSuccess,
  bookingAvailiabilityDetailsSuccess,
  clearBookingAvailiabilityDetailsSuccess,
  listOfVenueSlotsSuccess,
  getVenueBookedSlotListingSuccess,
  getUserDetailsSuccess,
  deleteVenueBookingSuccess,

  // venue details
  getVenueDetailsSuccess,
  getOtherUserProfileDetailsSuccess,
  updateProfileSuccess,
  getAcceptConnectionListSuccess,
  fetchVanueListSuccess,
  getPlayerListSuccess,
  getUserDetailSuccess,
  getEventListV2Success,
  getDetailsByReferenceIdSuccess,
  getJoinRequestDetailSuccess,
  getGameOnCardDetailSuccess,
  clearListOfVenueSlotsSuccess,
  getGameCardsSuccess,
} = slice.actions;

// *****************************Rating Api*********************************
export const getMarketPlaceRating = (requestParams) => async (dispatch) => {
  dispatch(apiFetching());
  api
    .post(`${PLAYMATEZAPI.rating.marketPlaceRating}`, requestParams)
    .then((response) => {
      let result = response.data;
      if (result?.status) {
        dispatch(
          getMarketPlaceRatingSuccess({
            data: result,
            page: requestParams?.page,
          })
        );
      } else {
        toast.error(result?.message || "Something Went Wrong");
      }
    })
    .catch(() => {
      dispatch(apiFailed());
    });
};

export const getVenueRating = (requestParams) => async (dispatch) => {
  dispatch(apiFetching());
  api
    .post(`${PLAYMATEZAPI.rating.venueRating}`, requestParams)
    .then((response) => {
      let result = response.data;
      if (result?.status) {
        dispatch(
          getVenueRatingSuccess({ data: result, page: requestParams?.page })
        );
      } else {
        toast.error(result?.message || "Something Went Wrong");
      }
    })
    .catch(() => {
      dispatch(apiFailed());
    });
};

// *****************************Venue Operations Action*********************************
export const getVenueAvailabilityDetails = () => async (dispatch) => {
  dispatch(apiFetching());
  api
    .get(PLAYMATEZAPI.venueOperation.venueAvailabilityDetails)
    .then((response) => {
      let result = response.data;
      if (result?.status) {
        dispatch(venueAvailabilityDetailsSuccess(result.data));
      } else {
        toast.error(result?.message || "Something Went Wrong");
      }
    })
    .catch(() => {
      dispatch(apiFailed());
    });
};

export const updateVenueAvailability =
  (requestParams, handleSuccess, setDeleteDialog, setMessageDialog) =>
  async (dispatch) => {
    dispatch(apiFetching("addUpdateVenue"));
    api
      .post(
        `${PLAYMATEZAPI.venueOperation.updateVenueAvailability}`,
        requestParams
      )
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          toast.success(result?.message);
          handleSuccess();
          setDeleteDialog(true);
          setMessageDialog({
            title: "Attention Required!",
            message:
              "Please update the arena time details in te booking availability section if needed.",
          });
        } else if (result?.status == 2) {
          toast.info(result?.message);
        } else {
          toast.error(result?.message || "Something Went Wrong");
        }
        dispatch(apiFailed("addUpdateVenue"));
      })
      .catch(() => {
        dispatch(apiFailed("addUpdateVenue"));
      });
  };

export const setVenueAvailability =
  (requestParams, handleSuccess) => async (dispatch) => {
    dispatch(apiFetching("addUpdateVenue"));
    api
      .post(
        `${PLAYMATEZAPI.venueOperation.setVenueAvailability}`,
        requestParams
      )
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          toast.success(result?.message);
          handleSuccess();
        } else if (result?.status == 2) {
          toast.info(result?.message);
        } else {
          toast.error(result?.message || "Something Went Wrong");
        }
        dispatch(apiFailed("addUpdateVenue"));
      })
      .catch(() => {
        dispatch(apiFailed("addUpdateVenue"));
      });
  };

export const getVenueSelectedSportsList =
  (setIsLoading) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .get(PLAYMATEZAPI.venueOperation.fetchSportListWithSelectedSport)
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          dispatch(venueSelectedSportsListSuccess(result.data));
        } else {
          toast.error(result?.message || "Something Went Wrong");
        }
        if (setIsLoading) {
          setIsLoading(false);
        }
      })
      .catch(() => {
        if (setIsLoading) {
          setIsLoading(false);
        }
        dispatch(apiFailed());
      });
  };

// add  arena
export const addUpdateArena =
  (request, handleAddUpdateSuccess) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(`${PLAYMATEZAPI.venueOperation.addUpdateArena}`, request)
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          toast.success(result?.message);
          handleAddUpdateSuccess(true);
        } else {
          toast.error(result?.message || "Something Went Wrong");
          handleAddUpdateSuccess(false);
        }
      })
      .catch(() => {
        handleAddUpdateSuccess(false);
        dispatch(apiFailed());
      });
  };
// add  arena
export const updateArena =
  (request, handleAddUpdateSuccess) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(`${PLAYMATEZAPI.venueOperation.updateArena}`, request)
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          toast.success(result?.message);
          handleAddUpdateSuccess(true);
        } else {
          toast.error(result?.message || "Something Went Wrong");
          handleAddUpdateSuccess(false);
        }
      })
      .catch(() => {
        handleAddUpdateSuccess(false);
        dispatch(apiFailed());
      });
  };

//   get booking availability list
export const getBookingAvailiabilityList =
  (request, setIsLoading) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(
        `${PLAYMATEZAPI.venueOperation.getBookingAvailiabilityList}`,
        request
      )
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          dispatch(
            getBookingAvailiabilityListSuccess({
              page: request?.page,
              data: result,
            })
          );
        } else {
          toast.error(result?.message || "Something Went Wrong");
        }
        if (setIsLoading) {
          setIsLoading(false);
        }
      })
      .catch(() => {
        if (setIsLoading) {
          setIsLoading(false);
        }
        dispatch(apiFailed());
      });
  };

// booking Availiability Details

export const bookingAvailiabilityDetails = (id) => async (dispatch) => {
  dispatch(apiFetching());
  api
    .get(
      `${PLAYMATEZAPI.venueOperation.bookingAvailiabilityDetails}?language=en&sportsId=${id} `
    )
    .then((response) => {
      let result = response.data;
      if (result?.status == 1) {
        dispatch(bookingAvailiabilityDetailsSuccess(result?.data));
      } else {
        toast.error(result?.message || "Something Went Wrong");
      }
    })
    .catch(() => {
      dispatch(apiFailed());
    });
};

export const clearBookingAvailiabilityDetails = () => async (dispatch) => {
  dispatch(clearBookingAvailiabilityDetailsSuccess(null));
};

// get List Of Venue Slots
export const getListOfVenueSlots = (request, setLoader) => async (dispatch) => {
  dispatch(apiFetching());
  api
    .post(PLAYMATEZAPI.venueOperation.listOfVenueSlots, request)
    .then((response) => {
      let result = response.data;

      if (result?.status == 1) {
        dispatch(listOfVenueSlotsSuccess(result));
      } else {
        toast.error(result?.message || "Something Went Wrong");
        dispatch(listOfVenueSlotsSuccess([]));
      }
      if (setLoader) {
        setLoader(false);
      }
    })
    .catch(() => {
      if (setLoader) {
        setLoader(false);
      }
      dispatch(apiFailed());
    });
};

// venue Booked Slot Listing
export const getVenueBookedSlotListing = (request) => async (dispatch) => {
  dispatch(apiFetching());
  api
    .post(PLAYMATEZAPI.venueOperation.venueBookedSlotListing, request)
    .then((response) => {
      let result = response.data;
      if (result?.status == 1) {
        dispatch(getVenueBookedSlotListingSuccess(result?.data));
      } else {
        toast.error(result?.message || "Something Went Wrong");
        dispatch(getVenueBookedSlotListingSuccess([]));
      }
    })
    .catch(() => {
      dispatch(getVenueBookedSlotListingSuccess([]));
      dispatch(apiFailed());
    });
};
// block Booking Slots
export const blockBookingSlots =
  (request, handleSuccess, setLoader) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(PLAYMATEZAPI.venueOperation.blockBookingSlots, request)
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          handleSuccess();
        } else {
          toast.error(result?.message || "Something Went Wrong");
        }
        setLoader?.(false);
      })
      .catch(() => {
        setLoader?.(false);
        dispatch(apiFailed());
      });
  };

// un block Booking Slots

export const unblockBookingSlots =
  (request, handleSuccess, setIsAllBlock, setLoader) => async (dispatch) => {
    dispatch(apiFetching());
    api
      .post(PLAYMATEZAPI.venueOperation.unblockBookingSlots, request)
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          handleSuccess();
          setIsAllBlock(false);
        } else {
          toast.error(result?.message || "Something Went Wrong");
        }
        setLoader?.(false);
      })
      .catch(() => {
        setLoader?.(false);
        dispatch(apiFailed());
      });
  };

// get user details
export const getUserDetails = (request) => async (dispatch) => {
  dispatch(apiFetching());
  api
    .get(PLAYMATEZAPI.user.getUserDetails)
    .then((response) => {
      let result = response.data;
      if (result?.status == 1) {
        dispatch(getUserDetailsSuccess(result));
      } else {
        toast.error(result?.message || "Something Went Wrong");
      }
    })
    .catch(() => {
      dispatch(apiFailed());
    });
};

// delete user account
export const deleteUserAccount = (handleLogout) => async (dispatch) => {
  dispatch(apiFetching("delete"));
  api
    .delete(PLAYMATEZAPI.user.deleteUserAccount)
    .then((response) => {
      let result = response.data;
      if (result?.status == 1) {
        handleLogout();
      } else {
        toast.error(result?.message || "Something Went Wrong");
      }
      dispatch(apiFailed("delete"));
    })
    .catch(() => {
      dispatch(apiFailed("delete"));
    });
};

// delete user account
export const deleteVenueBooking =
  (request, setDeleteDialog) => async (dispatch) => {
    dispatch(apiFetching("delete"));
    api
      .post(PLAYMATEZAPI.venueOperation.deleteBooking, request)
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          if (request?.type == TYPES?.VENUE_DELETE_TYPE) {
            dispatch(deleteVenueBookingSuccess(request?.id));
          }
          setDeleteDialog(false);
        } else {
          toast.error(result?.message || "Something Went Wrong");
        }
        dispatch(apiFailed("delete"));
      })
      .catch(() => {
        dispatch(apiFailed("delete"));
      });
  };

// get venue details
export const getVenueDetails =
  (cardId, setLoading, setShowDialog) => async (dispatch) => {
    api
      .get(`${PLAYMATEZAPI.venue.getVenueDetails}?cardId=${cardId}`)
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          dispatch(getVenueDetailsSuccess(result?.data));
          if (setShowDialog) {
            setShowDialog(true);
          }
        } else {
          toast.error(result?.message || "Something Went Wrong");
          dispatch(getVenueDetailsSuccess(null));
        }
        if (setLoading) {
          setLoading(false);
        }
      })
      .catch(() => {
        dispatch(getVenueDetailsSuccess(null));
        if (setLoading) {
          setLoading(false);
        }
      });
  };
// clear Venue Details
export const clearVenueDetails = () => async (dispatch) => {
  dispatch(getVenueDetailsSuccess(null));
};

// get  details by ReferenceId
export const getDetailsByReferenceId =
  (request, setLoading) => async (dispatch) => {
    api
      .post(PLAYMATEZAPI.checkReferenceId, request)
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          dispatch(getDetailsByReferenceIdSuccess(result?.data));
        } else {
          toast.error(result?.message || "Something Went Wrong");
        }
        if (setLoading) {
          setLoading(false);
        }
      })
      .catch(() => {
        dispatch(getDetailsByReferenceIdSuccess(null));
        if (setLoading) {
          setLoading(false);
        }
      });
  };
// clear ReferenceId Details
export const clearDetailsByReferenceId = () => async (dispatch) => {
  dispatch(getDetailsByReferenceIdSuccess(null));
};
// get  details by ReferenceId
export const getJoinRequestDetail = (id, setLoader) => async (dispatch) => {
  api
    .get(`${PLAYMATEZAPI.joinRequestDetail}/?cardId=${id}`)
    .then((response) => {
      let result = response.data;
      if (result?.status == 1) {
        dispatch(getJoinRequestDetailSuccess(result?.data));
      } else {
        toast.error(result?.message || "Something Went Wrong");
        dispatch(getJoinRequestDetailSuccess(null));
      }
      setLoader(false);
    })
    .catch(() => {
      setLoader(false);
      dispatch(getJoinRequestDetailSuccess(null));
    });
};
// clear ReferenceId Details
export const clearJoinRequestDetail = () => async (dispatch) => {
  dispatch(getJoinRequestDetailSuccess(null));
};
// get  details by ReferenceId
export const getGameOnCardDetail = (id, setLoader) => async (dispatch) => {
  api
    .get(`${PLAYMATEZAPI.gameOnCardDetail}/${id}`)
    .then((response) => {
      let result = response.data;
      if (result?.status == 1) {
        dispatch(getGameOnCardDetailSuccess(result?.data));
      } else {
        toast.error(result?.message || "Something Went Wrong");
        dispatch(getGameOnCardDetailSuccess(null));
      }
      setLoader(false);
    })
    .catch(() => {
      setLoader(false);
      dispatch(getGameOnCardDetailSuccess(null));
    });
};

// cancel slots by venue
export const cancelSlots =
  (request, SetMessage, fetchListing, setButtonLoader) => async (dispatch) => {
    api
      .post(PLAYMATEZAPI.venue.cancelSlots, request)
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          SetMessage(result.message);
          if (fetchListing) {
            fetchListing();
          }
        } else {
          toast.error(result?.message || "Something Went Wrong");
        }
        if (setButtonLoader) {
          setButtonLoader(false);
        }
      })
      .catch(() => {
        if (setButtonLoader) {
          setButtonLoader(false);
        }
      });
  };

export const cancelSlotsFromClub =
  (request, SetMessage, fetchListing, setButtonLoader) => async (dispatch) => {
    api
      .post(PLAYMATEZAPI.venue.cancelSlotsFromClub, request)
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          SetMessage(result.message);
          if (fetchListing) {
            fetchListing();
          }
        } else {
          toast.error(result?.message || "Something Went Wrong");
        }
        if (setButtonLoader) {
          setButtonLoader(false);
        }
      })
      .catch(() => {
        if (setButtonLoader) {
          setButtonLoader(false);
        }
      });
  };

// slot reschedule by venue
export const rescheduleSlotByVenue =
  (request, handleSuccess, setButtonLoader, onFailure) => async (dispatch) => {
    api
      .post(PLAYMATEZAPI.venue.rescheduleSlotByVenue, request)
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          handleSuccess(result.message);
        } else {
          toast.error(result?.message || "Something Went Wrong");
          onFailure?.();
        }
        if (setButtonLoader) {
          setButtonLoader(false);
        }
      })
      .catch(() => {
        onFailure?.();
        if (setButtonLoader) {
          setButtonLoader(false);
        }
      });
  };

export const rescheduleSlotByClub =
  (request, handleRescheduleSuccess, setLoader, onFailure) => async (dispatch) => {
    api
      .post(PLAYMATEZAPI.venue.rescheduleSlotByClub, request)
      .then((response) => {
        let result = response.data;
        if (result?.status) {
          handleRescheduleSuccess();
          toast.success(result?.message);
        } else {
          toast.error(result?.message);
          onFailure?.();
        }
        setLoader(false);
      })
      .catch((e) => {
        dispatch(apiFailed());
        onFailure?.();
        setLoader(false);
      });
  };

// get Other User Profile Details

export const getOtherUserProfileDetails =
  (userId, setLoader) => async (dispatch) => {
    api
      .get(`${PLAYMATEZAPI.user.getOtherUserProfileDetails}/${userId}/en`)
      .then((response) => {
        let result = response.data;
        if (result?.status == 1) {
          dispatch(getOtherUserProfileDetailsSuccess(result?.data));
        } else {
          toast.error(result?.message || "Something Went Wrong");
        }
        if (setLoader) {
          setLoader(false);
        }
      })
      .catch(() => {
        if (setLoader) {
          setLoader(false);
        }
      });
  };

// update user profile
export const updateProfile = (request, setLoading) => async (dispatch) => {
  api
    .put(`${PLAYMATEZAPI.updateProfile}`, request)
    .then((response) => {
      let result = response.data;
      if (result?.status == 1) {
        toast.success(result?.message);
        secureLocalStorage.setItem(
          process.env.REACT_APP_USER_STORAGE_KEY,
          result?.data
        );
        dispatch(updateProfileSuccess(result?.data));
      } else {
        toast.error(result?.message || "Something Went Wrong");
      }
      if (setLoading) {
        setLoading(false);
      }
    })
    .catch(() => {
      if (setLoading) {
        setLoading(false);
      }
    });
};

// get connection listing
export const getAcceptConnectionList = (page, perPage) => async (dispatch) => {
  api
    .get(
      `${PLAYMATEZAPI.user.getAcceptConnectionList}/?page=${page}&perPage=${perPage}`
    )
    .then((response) => {
      let result = response.data;
      if (result?.status == 1) {
        dispatch(getAcceptConnectionListSuccess(result));
      } else {
        toast.error(result?.message || "Something Went Wrong");
      }
    })
    .catch(() => {});
};

// report user
export const userReports = (request, handleSuccess) => async (dispatch) => {
  api
    .post(PLAYMATEZAPI.user.userReports, request)
    .then((response) => {
      let result = response.data;
      if (result?.status == 1) {
        handleSuccess(true);
        toast.success(result?.message);
      } else {
        handleSuccess(false);
        toast.error(result?.message || "Something Went Wrong");
      }
    })
    .catch(() => {
      handleSuccess(false);
    });
};
export const getVenueList = (request) => async (dispatch) => {
  api
    .post(PLAYMATEZAPI.user.venueListBasedOnPrimarySport, request)
    .then((response) => {
      let result = response.data;
      if (result?.status == 1) {
        dispatch(fetchVanueListSuccess(result?.data));
      }
    })
    .catch(() => {});
};

export const getPlayerList = (request, setLoader) => async (dispatch) => {
  dispatch(apiFetching());

  api
    .post(PLAYMATEZAPI.dashboard.getRequestToJoinListV2, request)
    .then((response) => {
      let result = response.data;

      if (result?.status == 1) {
        dispatch(
          getPlayerListSuccess({
            page: request?.page,
            data: result,
          })
        );
      } else {
        toast.error(result?.message || "Something Went Wrong");
      }

      dispatch(apiFailed());
      if (setLoader) setLoader(false);
    })
    .catch(() => {
      dispatch(apiFailed());
      if (setLoader) setLoader(false);
    });
};

export const getEventListV2 = (request, setLoader) => async (dispatch) => {
  dispatch(apiFetching());

  api
    .post(PLAYMATEZAPI.dashboard.getEventListV2, request)
    .then((response) => {
      let result = response.data;

      if (result?.status == 1) {
        dispatch(
          getEventListV2Success({
            page: request?.page,
            data: result,
          })
        );
      } else {
        toast.error(result?.message || "Something Went Wrong");
        dispatch(
          getEventListV2Success({
            page: request?.page,
            data: null,
          })
        );
      }

      dispatch(apiFailed());
      if (setLoader) setLoader(false);
    })
    .catch(() => {
      dispatch(apiFailed());
      dispatch(
        getEventListV2Success({
          page: request?.page,
          data: null,
        })
      );
      if (setLoader) setLoader(false);
    });
};

export const getGameCards = (request, setLoader) => async (dispatch) => {
  dispatch(apiFetching());

  api
    .post(PLAYMATEZAPI.dashboard.getGameCards, request)
    .then((response) => {
      let result = response.data;

      if (result?.status == 1) {
        dispatch(
          getGameCardsSuccess({
            page: request?.page,
            data: result,
          })
        );
      } else {
        toast.error(result?.message || "Something Went Wrong");
        dispatch(
          getGameCardsSuccess({
            page: request?.page,
            data: null,
          })
        );
      }

      dispatch(apiFailed());
      if (setLoader) setLoader(false);
    })
    .catch(() => {
      dispatch(apiFailed());
      dispatch(
        getGameCardsSuccess({
          page: request?.page,
          data: null,
        })
      );
      if (setLoader) setLoader(false);
    });
};
export const getUserDetail = (userId, setLoader) => async (dispatch) => {
  dispatch(apiFetching());

  api
    .get(`${PLAYMATEZAPI.user.getUserDetailV2}/${userId}/en`)
    .then((response) => {
      let result = response.data;

      if (result?.status == 1) {
        dispatch(getUserDetailSuccess(result?.data));
      } else {
        toast.error(result?.message || "Something went wrong");
        dispatch(getUserDetailSuccess(null));
      }

      dispatch(apiFailed());
      if (setLoader) setLoader(false);
    })
    .catch(() => {
      dispatch(apiFailed());
      dispatch(getUserDetailSuccess(null));
      if (setLoader) setLoader(false);
    });
};

export const sendJoinAllCardRequest =
  (request, setLoader, onSuccess) => async (dispatch) => {
    dispatch(apiFetching());

    api
      .post(PLAYMATEZAPI.dashboard.sendJoinAllCardRequest, request)
      .then((response) => {
        let result = response.data;

        if (result?.status == 1) {
          toast.success(result?.message || "Request sent successfully");
          if (onSuccess) onSuccess();
        } else {
          toast.error(result?.message || "Something went wrong");
        }

        dispatch(apiFailed());
        if (setLoader) setLoader(false);
      })
      .catch(() => {
        dispatch(apiFailed());
        toast.error("Something went wrong");
        if (setLoader) setLoader(false);
      });
  };

export const clearListOfVenueSlots = () => async (dispatch) => {
  dispatch(clearListOfVenueSlotsSuccess());
};
